module.exports = __webpack_public_path__ + "img/canada-external-causes-male.92c0bc78.png";